var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmpersand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ampersand",
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4766 28.0242L46.2125 34.4595L39.6758 33.3449C38.9398 37.6493 36.8775 41.0977 33.4888 43.6903C30.433 46.0282 27.384 47.0899 24.3418 46.8752C21.3067 46.6071 18.9095 45.3233 17.1503 43.0239C14.1874 39.1511 13.816 34.5907 16.0364 29.3425C13.0279 28.6703 10.7392 27.1836 9.17047 24.8823C7.74058 22.7626 7.26567 20.5118 7.74574 18.13C8.22581 15.7481 9.67608 13.6313 12.0965 11.7794C15.4087 9.14949 19.0159 8.69207 22.9182 10.4072L20.7567 16.2338C18.729 15.3389 17.0042 15.4355 15.5821 16.5234C14.8489 17.1324 14.4521 17.8676 14.3918 18.7292C14.3083 19.5605 14.5408 20.3659 15.0892 21.1455C15.5059 21.6901 16.1237 22.1528 16.9426 22.5335C17.7615 22.9143 18.4612 23.1704 19.0415 23.302C19.6521 23.4105 20.568 23.5731 21.7892 23.79L33.6716 25.7792C33.4308 23.709 33.0912 21.6664 32.6529 19.6515L38.9353 18.0827C39.4879 21.689 39.809 24.5851 39.8985 26.771L47.4766 28.0242ZM31.0176 37.4508C32.2775 36.1511 33.1182 34.4287 33.5396 32.2836L22.0123 30.3825C21.4697 31.8049 21.2698 33.2049 21.4125 34.5827C21.5552 35.9604 22.0237 37.1369 22.8178 38.1122C23.774 39.2993 25.0629 39.8242 26.6845 39.6867C28.3061 39.5493 29.7505 38.804 31.0176 37.4508Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmpersand);
export default __webpack_public_path__ + "static/media/ampersand.06faa80813ecea7725a81410a9e9a67e.svg";
export { ForwardRef as ReactComponent };